<template>
  <base-auth>
   <div class="mx-auto mt-2 text-center">
        <ul class="p-0 m-0 d-flex align-items-center justify-content-center">
            <li class="px-3 py-2  mx-2"><router-link to="/login">ورود</router-link></li>
            <li class="px-3 py-2 mx-2"><router-link :to="`/register/${ $route.params.referer_id }`">ثبت نام</router-link></li>
        </ul>
    </div>
      <form @submit.prevent="register" class="mt-1">
          <div class="card-login-register w-75 ma-auto">
            <div class="login-form login-form-register pt-2 pb-3">
                <div class="flex-column px-5 pt-3">
                    <div> 
                        <div>
                            <div class="d-flex align-items-center">
                            <input type="radio" name="type-account" class="type-account-radio" @click="is_real_user = true">
                            <span class="font-weight-bold mr-2">حساب حقیقی</span>
                            </div>
                            <!-- <div>
                                <p class="pt-1 text-right pr-2">
                                    برای ایجاد حساب حقیقی روی این دکمه کلیک کنید
                                </p>
                            </div> -->
                        </div>
                    </div>
                    <div class="mt-3">
                        <div>
                        <div class="d-flex align-items-center">
                            <input type="radio" name="type-account" class="type-account-radio" @click="is_real_user = flase">
                            <span class="font-weight-bold mr-2">حساب حقوقی</span>
                        </div>
                        <!-- <div>
                            <p class="pt-1 text-right pr-2">
                                برای ایجاد حساب از نوع حقوقی اینجا کلیک کنید
                            </p>
                        </div> -->
                        </div>
                    </div>
                </div>
                <div v-if="is_real_user !== null">
                    <div v-if="is_real_user" class="form-field form-field-register">
                        <input
                            type="text"
                            :placeholder="$t('auth.placeholder.first_name')"
                            name="first_name"
                            v-model="first_name"
                        >
                    </div>
                    <div v-if="is_real_user" class="form-field form-field-register">
                        <input
                            type="text"
                            :placeholder="$t('auth.placeholder.last_name')"
                            name="last_name"
                            v-model="last_name"
                        >
                    </div>
                    <div v-if="!is_real_user" class="form-field form-field-register">
                        <input
                            type="text"
                            :placeholder="$t('label.com_name_fa')"
                            name="com_name_fa"
                            v-model="com_name_fa"
                        >
                    </div>
                    <div class="form-field form-field-register">
                        <input
                            type="text"
                            :placeholder="$t('auth.placeholder.phone')"
                            name="phone"
                            v-model="phone"
                            id="phone"
                        >
                    </div>
                    <div class="form-field form-field-register">
                        <input
                            type="password"
                            placeholder="رمز عبور"
                            name="password"
                            autocomplete="off"
                            v-model="password"
                        >
                    </div>
                    <div class="form-link" style="width: auto;">
                        <div class="mb-4" style="width: auto;">
                            <kt-form-check id="agree" name="agree" v-model="agree">
                            </kt-form-check>
                            <label class="px-2">
                            <a class="text-primary" href="https://paystar.ir/terms" target="_blank">
                                {{ $t('auth.im_agree_with_terms_and_condition') }}
                            </a>
                            </label>
                        </div>
                    </div>
                    <div class="login-footer login-footer-register mt-3">
                    <input type="submit" id="login_signup_submit" value="ثبت نام">
                    </div>
                </div>
            </div>
          </div>
    </form>
  </base-auth>
</template>

<script>
import { authService } from '@/common/api.service';
import baseAuth from '@/components/base-register'
import { KTApp } from '@/plugins/core/app'
import $ from 'jquery'
import {blackList} from "../constants/securityStatus";
import {mapActions} from "vuex";
import { userTypes, userTypesStr } from '@/constants/userTypes';
import { i18n } from "@/plugins/i18n";
import Register from './Register'
import Login from './Login'

    export default {
        data() {
            return {
                user_types: userTypes,
                user_types_str: userTypesStr,
                com_name_fa: '',
                is_real_user: null,
                first_name: '',
                last_name: '',
                phone: '',
                password: '',
                agree: false,
                referer_id: this.$route.params.referer_id,
                activeComponent:'login'
            }
        },
        computed: {
        ...mapActions('auth',['sendVerifyStatus']),

        },
        components: {
            'base-auth': baseAuth,
        },
        methods: {
            register(e) {
                let form = $(e.target)
                let btn = $('#login_signup_submit')

                form.validate({
                    ignore: ".ignore",
                    rules: {
                        com_name_fa: {
                            required: () => {
                            return !this.is_real_user;
                            },
                        },
                        first_name: {
                            required: () => {
                            return this.is_real_user;
                            },
                        },
                        last_name: {
                            required: () => {
                            return this.is_real_user;
                            },
                        },
                        password: {
                            required: true
                        },
                        phone: {
                            required: true
                        },
                        agree: {
                            required: true
                        }
                    }
                })

                if(!form.valid()) {
                    return
                }

                let referer = null
                if(this.$route.params.referer_id) {
                    referer = this.$route.params.referer_id
                }

                let params = {
                    user_type: this.is_real_user ? this.user_types.REAL : this.user_types.LEGAL,
                    com_name_fa: this.com_name_fa,
                    first_name: this.first_name,
                    last_name: this.last_name,
                    phone: this.phone,
                    password: this.password,
                    agree: this.agree,
                    referer_id: referer
                }

                KTApp.progress(btn)

                this.$store.dispatch('auth/register', params)
                    .then((response) => {
                        if(response.status === blackList.FORBIDDEN) {
                            this.showMsg(form, 'danger', response.message)
                            return;
                        }
                        this.showMsg(form, 'success', response.data.message)
                        this.$store.dispatch('auth/setRegisterData', params)
                        this.$router.push('/verify')
                    })
                    .catch((response) => {
                        form.validate().showErrors(response.data.data)
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            },
            getCookie(name) {
                let cookieName = name + "="
                let decodedCookie = decodeURIComponent(document.cookie)
                let cookieArray = decodedCookie.split(';')

                for(let i = 0; i <cookieArray.length; i++) {
                    while (cookieArray[i].charAt(0) === ' ') {
                        cookieArray[i] = cookieArray[i].substring(1);
                    }
                    if (cookieArray[i].indexOf(cookieName) === 0) {
                        return cookieArray[i].substring(cookieName.length, cookieArray[i].length);
                    }
                }

                return "";
            },
            sendVerify(e) {
                let btn = $(e.target)
                let form = $('.kt-form')
                let phone = $('#phone')

                let params = {
                    phone: phone.val(),
                }

                KTApp.progress(btn)
                this.$store.dispatch('auth/sendVerifyRegister', params)
                    .then(response => {
                        this.showMsg($('.kt-form'), 'success', response.message)
                        this.sent = true
                        this.sendVerifyStatus
                    })
                    .catch(response => {
                        this.showMsg($('.kt-form'), 'danger', response.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
            }
        },
        mounted() {
            if (!this.getCookie('referer_id')) {
                let date = new Date()
                date.setTime(date.getTime() + (7*24*60*60*1000))
                let expires = "expires="+ date.toUTCString()

                document.cookie = "referer_id =" + this.referer_id +";" + expires + ";path=/"

                authService.addClickCounter(this.referer_id)
            }
        }
    }
</script>


<style scoped>
ul{
    list-style: none;
}
ul li{
    cursor: pointer;
    font-weight: bold;
    font-size: 1.2rem;

}
li a:hover{
    color: #00BEA5!important;
}
.router-link-active{
    color: #00BEA5;
     border-bottom: 2px solid #00BEA5;
    padding-bottom: 5px;
}
.type-account-radio{
   transform: scale(1.3);
}
::placeholder{
  padding-right: 5px;
}
</style>